// removed by extract-text-webpack-plugin
module.exports = {"ratings":"Ratings__ratings___1xK8n","text":"Ratings__text___h9Dm6","icon":"Ratings__icon___1T0nN"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/candidate/employerReview/components/Ratings.scss
// module id = 1817
// module chunks = 0